import { J2Programinstallation } from '@e3dc-react/icons'
import { FavoriteBorderOutlined, Favorite } from '@mui/icons-material'
import { Button, IconButton, Typography } from '@mui/material'
import React, { useState } from 'react'
import { makeStyles } from 'tss-react/mui'
import { ProgressBarSteps, SystemConfigureType } from '../../types'
import { useTypedSelector } from 'src/State/RootReducer'
import { useParams } from 'react-router-dom'
import useModals from 'src/Hooks/useModals'

interface SaveConfiguratorProps {
  step: number
}

const useStyles = makeStyles()(theme => ({
  buttonText: {
    marginLeft: theme.spacing(1),
  },
}))

/*
 * This component renders the button to override or save configurator.
 */
const SaveConfigurator: React.FC<SaveConfiguratorProps> = ({ step }) => {
  const { classes } = useStyles()
  const { openShopSaveSystemConfiguration, openShopUpdateSystemConfiguration } = useModals()
  const [saved, setSaved] = useState<boolean>(false)
  const { id } = useParams<{ id: SystemConfigureType | string }>()
  const configuratorItems = useTypedSelector(state => state.systemStorage.items)
  const configurator = configuratorItems.length > 0 ? configuratorItems[0] : null
  const isNotFavorite = Boolean(id !== SystemConfigureType.Favorite)

  if (!configurator || step !== ProgressBarSteps.AdditionalComponent) return null

  if (isNotFavorite)
    return (
      <IconButton
        onClick={() => {
          openShopSaveSystemConfiguration({
            onConfirm: () => setSaved(true),
          })
        }}
      >
        <Button variant="outlined" size="large">
          {saved ? <Favorite /> : <FavoriteBorderOutlined />}
        </Button>
      </IconButton>
    )

  return (
    <IconButton
      onClick={() => {
        if (id) openShopUpdateSystemConfiguration({ configuratorId: id })
      }}
    >
      <Button variant="contained" size="large">
        <J2Programinstallation />
        <Typography sx={{ display: { md: 'inherit', sm: 'none' } }} variant="body2" className={classes.buttonText}>
          {'shop.progress-bar.override'}
        </Typography>
      </Button>
    </IconButton>
  )
}

export default SaveConfigurator
